module.exports = __webpack_public_path__ + "img/dycar.f5c7ad60.webp";